/* eslint-disable no-redeclare */
/* eslint-disable no-empty */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import linq from "linq";
import Vue from "vue";
const apicloud_scan = function (callback,exclick) {
    nfc.scan(callback);
    var name = "";
    var key = "";
    var category = "";
    var isArray = false;
    switch (api.deviceModel) {
        case "simphone":
        case "N5":
        case "thimfone":
            name = "android.intent.action.RECEIVE_SCANDATA_BROADCAST";
            key = "android.intent.extra.SCAN_BROADCAST_DATA";
            break;
        case "C6000":
        case "handheld":
            name = "com.scanner.broadcast";
            key = "data";
            break;
        case "PDA":
            name = "com.android.server.scannerservice.broadcast";
            key = "scannerdata";
            break;
        case "DS100":
        case "DS10":
            name = "scan.rcv.message";
            key = "barocode"
            isArray = true;
            break;
        case "m71":
        case "m82":
            name = "com.android.decodewedge.decode_action";
            category = "com.android.decodewedge.decode_category";
            key = "com.android.decode.intentwedge.barcode_string";
            break
        case "M5":
            name = "com.yunlian.scan.result";
            key = "result";
            break;
        case "i6200S":
        case "i6310":
        case "i6310A":
            name = "android.intent.ACTION_DECODE_DATA";
            key = "barcode_string";
            break;
        case "NLS-NFT10":
            name = "nlscan.action.SCANNER_RESULT";
            key = "SCAN_BARCODE1";
            break;
        case "SC40G":
        case "FG80":
            //思必拓
            name="com.speedata.showdecodedata";
            key="message"
            break;
        case "L2Ks":
            name="com.sunmi.scanner.ACTION_DATA_CODE_RECEIVED";
            key="data"
            break;
        case "NLS-MT69":
            name="nlscan.action.SCANNER_RESULT";
            key="SCAN_BARCODE1";
            break;
        default:
            // alert("暂不支持该设备扫码,型号:"+api.deviceModel+",请联系管理员");
            //昌顺新机器暂时用default
            name = "nlscan.action.SCANNER_RESULT";
            key = "SCAN_BARCODE1";
            break;
    }
    var obj = api.require('scanhelper');
    if (obj != null) {
        obj.addEventListener({
            name: name,
            key: key,
            category: category,
            isArray: isArray
        }, function (ret) {
            var result = ret.result;
            if (result.indexOf("\r\n") > -1) {
                result = result.replace("\r\n", "");
            }
            callback(result);
        });
    }
}
const vkeyboard={
    timeoutid:0,
    code:"",
    keylist:[],
    scan:function(callback,exclick,onKeyPress){
        document.onkeydown=function(event){
            if(typeof onKeyPress=="function"){
                onKeyPress(event)
            }
            vkeyboard.keylist.push(event.keyCode)
            clearTimeout(vkeyboard.timeoutid);
            if(event.keyCode==120||event.keyCode==0){
                //屏蔽PDA扫码按键
                return;
            }
            if(event.keyCode==13 || event.key=="ArrowDown"){
                vkeyboard.commit(callback,exclick);
            }
            else if((event.keyCode>31 && event.keyCode<127 ) || linq.from([189]).any(p=>p==event.keyCode)){
                vkeyboard.code+=event.key;
                vkeyboard.timeoutid=setTimeout(() => {
                    vkeyboard.commit(callback,exclick);
                }, 100);
            }
        }
    },
    commit: function(callback, exclick) {
        if (vkeyboard.code.length > 4) {
            // alert(JSON.stringify(vkeyboard.keylist))
            callback(vkeyboard.code)
        } else {
            if (exclick) {
                exclick(vkeyboard.code[vkeyboard.code.length - 1], vkeyboard.code)
            }
        }
        vkeyboard.code = ''
        vkeyboard.keylist = []
    }
}
const nfc={
    obj:null,
    usetagId:true,
    scan:function(callback){
        nfc.obj = api.require('nfc');
        if(nfc.obj==null)
            return;
        nfc.obj.addEventListener(function(ret, err){
            if(ret.status==true){
                if(nfc.usetagId==false){
                    if(!ret.result){
                        alert("NFC读取失败,请检查是否已经损坏!");
                    }
                    else{
                        callback(ret.result);
                    }
                }
                else{
                    callback(nfc.uid2id(ret.tagId));
                }
            }
        });
    },
    uid2id(uid){
        var newuid=uid.substring(6,8)+uid.substring(4,6)+uid.substring(2,4)+uid.substring(0,2);
        let res = parseInt(newuid, 16);
        return res;
    }
}
const scan = function (callback,exclick,onKeyPress) {
    vkeyboard.scan(callback,exclick,onKeyPress);
}
export default {
    scan,
    apicloud_scan,
    nfc
}
